module.exports = __webpack_public_path__ + "img/40_00_000_350.f411284f.jpg";